import { useLocation, useNavigate } from "react-router-dom";

export const useUrlParams = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const page = searchParams.get("page") || 1;
  const tab = searchParams.get("tab") || "";
  const filters: { [key: string]: any } = {};

  // List of keys that should always be treated as arrays
  const arrayKeys = ["roles", "licenceGroupIds", "userGroups", "licenseTypeClassifiers"];

  searchParams.forEach((value, key) => {
    if (key !== "page" && key !== "tab") {
      if (filters[key]) {
        if (Array.isArray(filters[key])) {
          filters[key].push(decodeURIComponent(value));
        } else {
          filters[key] = [filters[key], decodeURIComponent(value)];
        }
      } else {
        filters[key] = arrayKeys.includes(key) ? [decodeURIComponent(value)] : decodeURIComponent(value);
      }
    }
  });

  const constructUrlParams = (
    overridePage?: number | string,
    overrideTab?: number,
    overrideFilters?: { [key: string]: any }
  ) => {
    const finalPage = overridePage !== undefined ? overridePage : page;
    const finalTab = overrideTab !== undefined ? overrideTab : tab;
    const finalFilters = overrideFilters !== undefined ? overrideFilters : filters;
    let params = `?page=${finalPage}${finalTab ? `&tab=${finalTab}` : ""}`;

    Object.keys(finalFilters).forEach((key) => {
      if (finalFilters[key]) {
        if (Array.isArray(finalFilters[key])) {
          finalFilters[key].forEach((val: string) => {
            params += `&${key}=${encodeURIComponent(val)}`;
          });
        } else {
          params += `&${key}=${encodeURIComponent(finalFilters[key])}`;
        }
      }
    });

    return params;
  };

  const clearUrlFilters = () => {
    let params = `?page=${page}${tab ? `&tab=${tab}` : ""}`;
    navigate(`${location.pathname}${params}`);
  };

  const setUrlFilters = (newFilters: { [key: string]: any }) => {
    const params = constructUrlParams(page, +tab, newFilters);
    navigate(`${location.pathname}${params}`);
  };

  return { page, tab, filters, constructUrlParams, clearUrlFilters, setUrlFilters };
};
